import { Link } from "react-router-dom";

/* ============================================================================
 * Mynte — Premium, considered, editorial. Bone + brass + forest.
 * Cormorant Garamond display + IBM Plex Sans body. 1px borders, no shadows.
 * ========================================================================== */

const P = {
  bg: "#F4F4F0", surface: "#FFFFFF", text: "#1E2019", muted: "#6E7569",
  brass: "#A88E6D", forest: "#394A3E", border: "#E2E2DE", paper: "#EBE9E1",
};
const D = "'Cormorant Garamond', 'Times New Roman', serif";
const B = "'IBM Plex Sans', system-ui, sans-serif";
const M = "'IBM Plex Mono', monospace";

export default function MockupMynte() {
  return (
    <div style={{ background: P.bg, color: P.text, fontFamily: B, minHeight: "100vh" }}>
      <TopBar />
      <section style={{ maxWidth: 1180, margin: "0 auto", padding: "0 28px 100px" }}>
        <Section label="01 · LANDING"><MynteLanding /></Section>
        <Section label="02 · EXTENSION POPUP">
          <div style={{ padding: "60px 0", background: P.paper, border: `1px solid ${P.border}`, display: "flex", justifyContent: "center" }}>
            <MyntePopup />
          </div>
        </Section>
        <Section label="03 · CONSUMER DASHBOARD"><MynteDashboard /></Section>
      </section>
    </div>
  );
}

function TopBar() {
  return (
    <div style={{ position: "sticky", top: 0, zIndex: 20, background: P.bg, borderBottom: `1px solid ${P.border}` }}>
      <div style={{ maxWidth: 1180, margin: "0 auto", padding: "16px 28px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Link to="/mockups" style={{ fontSize: 11, color: P.muted, textDecoration: "none", letterSpacing: "0.2em", fontWeight: 500 }}>← ALLE RETNINGER</Link>
        <span style={{ fontFamily: D, fontSize: 28, fontWeight: 400, letterSpacing: "-0.01em" }}>Mynte</span>
        <span style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.25em", color: P.muted }}>RETNING 02 / 03</span>
      </div>
    </div>
  );
}

function Section({ label, children }) {
  return (
    <div style={{ paddingTop: 64 }}>
      <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.muted, marginBottom: 18 }}>{label}</div>
      {children}
    </div>
  );
}

function MynteLanding() {
  return (
    <div style={{ background: P.surface, border: `1px solid ${P.border}` }}>
      <nav style={{ padding: "24px 56px", borderBottom: `1px solid ${P.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontFamily: D, fontSize: 28, fontWeight: 400, letterSpacing: "-0.01em" }}>Mynte</span>
        <div style={{ display: "flex", gap: 36, fontFamily: M, fontSize: 11, letterSpacing: "0.2em", color: P.muted }}>
          <span>FORTELLING</span><span>METODE</span><span>MEDLEMSKAP</span>
        </div>
        <span style={{ fontFamily: M, fontSize: 11, letterSpacing: "0.2em", color: P.text, borderBottom: `1px solid ${P.text}`, paddingBottom: 2 }}>LOGG INN ↗</span>
      </nav>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", borderBottom: `1px solid ${P.border}` }}>
        <div style={{ padding: "80px 56px", borderRight: `1px solid ${P.border}` }}>
          <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.muted, marginBottom: 36 }}>EST. 2026 · OSLO</div>
          <h1 style={{ fontFamily: D, fontSize: "clamp(64px, 8vw, 120px)", fontWeight: 300, letterSpacing: "-0.03em", lineHeight: 0.92, margin: 0 }}>
            Kunsten<br /><em style={{ color: P.brass }}>å handle</em><br />smart.
          </h1>
          <div style={{ marginTop: 48, maxWidth: 380, fontSize: 15, lineHeight: 1.7, color: P.muted }}>
            Mynte er et stille medlemskap for nordmenn som vil ha mer ut av hver eneste handel. Vi sporer poeng, bonus og betalingsmetoder — diskret, presist, og uten markedsføringsstøy.
          </div>
          <div style={{ marginTop: 48, display: "flex", gap: 18, alignItems: "center" }}>
            <button style={{ background: P.text, color: P.surface, border: "none", padding: "16px 28px", fontFamily: M, fontWeight: 500, fontSize: 12, letterSpacing: "0.2em", cursor: "pointer" }}>PRØV I 14 DAGER →</button>
            <span style={{ fontFamily: M, fontSize: 11, letterSpacing: "0.15em", color: P.muted }}>15 KR / MÅNED</span>
          </div>
        </div>
        <div style={{ background: P.paper, padding: "56px", position: "relative" }}>
          <div style={{ background: P.surface, border: `1px solid ${P.border}`, padding: 32, maxWidth: 420, marginLeft: "auto" }}>
            <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.25em", color: P.muted, marginBottom: 12 }}>SERTIFISERT FORHANDLER · KOMPLETT.NO</div>
            <div style={{ fontFamily: D, fontSize: 36, fontWeight: 400, letterSpacing: "-0.02em", lineHeight: 1 }}>Komplett</div>
            <div style={{ marginTop: 8, fontFamily: M, fontSize: 11, color: P.muted, letterSpacing: "0.1em" }}>ELEKTRONIKK · OSLO</div>
            <div style={{ marginTop: 28, borderTop: `1px solid ${P.border}`, paddingTop: 20 }}>
              <div style={{ display: "flex", justifyContent: "space-between", fontFamily: M, fontSize: 11, letterSpacing: "0.15em", color: P.muted, marginBottom: 12 }}><span>BETALINGSMETODER</span><span>04</span></div>
              {["Visa","Mastercard","Vipps","Klarna"].map((m) => (
                <div key={m} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: `1px solid ${P.border}`, fontSize: 14 }}><span>{m}</span><span style={{ fontFamily: M, fontSize: 11, color: P.brass }}>•</span></div>
              ))}
            </div>
            <div style={{ marginTop: 28, padding: 18, background: P.forest, color: P.surface }}>
              <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.25em", color: P.brass, marginBottom: 6 }}>EUROBONUS</div>
              <div style={{ fontFamily: D, fontSize: 24, fontWeight: 400, lineHeight: 1.1 }}>15 poeng per 100 kr</div>
            </div>
          </div>
        </div>
      </div>

      {/* Three editorial features */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", borderBottom: `1px solid ${P.border}` }}>
        {[
          { n: "01", t: "Diskresjon", b: "Ingen popups, ingen notifikasjoner. Mynte virker stille i bakgrunnen og dukker opp kun når noe faktisk lønner seg." },
          { n: "02", t: "Presisjon", b: "Hver bonus og hvert poeng er manuelt verifisert mot kilde — vi gjetter aldri, vi bekrefter." },
          { n: "03", t: "Verdig", b: "Et medlemskap som koster mindre enn én latte i måneden, og gir tilbake i timer du ikke trenger å lete etter beste betaling." },
        ].map((f) => (
          <div key={f.n} style={{ padding: "48px 36px", borderRight: `1px solid ${P.border}` }}>
            <div style={{ fontFamily: M, fontSize: 11, letterSpacing: "0.3em", color: P.brass }}>{f.n}</div>
            <div style={{ fontFamily: D, fontSize: 36, fontWeight: 400, marginTop: 24, letterSpacing: "-0.02em" }}>{f.t}</div>
            <div style={{ marginTop: 16, fontSize: 14, lineHeight: 1.65, color: P.muted }}>{f.b}</div>
          </div>
        ))}
      </div>

      {/* Pricing */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", padding: "72px 56px", gap: 56, alignItems: "center" }}>
        <div>
          <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.muted, marginBottom: 24 }}>MEDLEMSKAP</div>
          <h2 style={{ fontFamily: D, fontSize: 64, fontWeight: 300, lineHeight: 1, margin: 0, letterSpacing: "-0.03em" }}>Femten kroner.<br /><em style={{ color: P.brass }}>Hver måned belønnes du.</em></h2>
        </div>
        <div style={{ border: `1px solid ${P.border}`, padding: 36, background: P.surface }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", paddingBottom: 24, borderBottom: `1px solid ${P.border}` }}>
            <span style={{ fontFamily: D, fontSize: 72, fontWeight: 300, letterSpacing: "-0.04em", lineHeight: 1 }}>15<span style={{ fontFamily: M, fontSize: 13, color: P.muted, letterSpacing: "0.15em" }}> KR/MND</span></span>
            <span style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.25em", color: P.muted }}>14 DAGER GRATIS</span>
          </div>
          <ul style={{ listStyle: "none", padding: 0, margin: "24px 0", fontSize: 14, lineHeight: 2 }}>
            {["Ubegrenset skanning","Verifiserte bonusprogrammer","Månedlig bonusoversikt","Ingen binding"].map((l) => (
              <li key={l} style={{ borderBottom: `1px solid ${P.border}`, paddingLeft: 24, position: "relative" }}><span style={{ position: "absolute", left: 0, color: P.brass }}>—</span>{l}</li>
            ))}
          </ul>
          <button style={{ width: "100%", background: P.text, color: P.surface, border: "none", padding: 16, fontFamily: M, fontWeight: 500, fontSize: 12, letterSpacing: "0.25em", cursor: "pointer" }}>BLI MEDLEM →</button>
        </div>
      </div>
    </div>
  );
}

function MyntePopup() {
  return (
    <div style={{ width: 360, background: P.surface, border: `1px solid ${P.border}`, fontFamily: B }}>
      <div style={{ padding: "16px 20px", borderBottom: `1px solid ${P.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontFamily: D, fontSize: 22, fontWeight: 400 }}>Mynte</span>
        <span style={{ fontFamily: M, fontSize: 10, color: P.muted, letterSpacing: "0.15em" }}>↻ OPPDATER</span>
      </div>
      <div style={{ padding: "20px 20px 12px" }}>
        <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.25em", color: P.muted, marginBottom: 6 }}>NÅVÆRENDE NETTSTED</div>
        <div style={{ fontFamily: D, fontSize: 26, fontWeight: 400, letterSpacing: "-0.01em" }}>komplett.no</div>
      </div>

      <div style={{ margin: "0 20px", padding: "16px 18px", border: `1px solid ${P.brass}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontFamily: M, fontSize: 9, letterSpacing: "0.25em", color: P.brass, marginBottom: 4 }}>SERTIFISERT</div>
          <div style={{ fontFamily: D, fontSize: 18, fontWeight: 400 }}>Komplett · 4 metoder</div>
        </div>
        <span style={{ fontFamily: M, fontSize: 10, color: P.brass, letterSpacing: "0.15em" }}>✓</span>
      </div>

      <div style={{ padding: "20px 20px 8px" }}>
        <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.25em", color: P.muted, marginBottom: 12 }}>EUROBONUS</div>
        <div style={{ padding: 18, background: P.forest, color: P.surface }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
            <div style={{ fontFamily: D, fontSize: 28, fontWeight: 400, letterSpacing: "-0.01em", lineHeight: 1.05 }}>15 poeng</div>
            <span style={{ fontFamily: M, fontSize: 10, color: P.brass, letterSpacing: "0.15em" }}>PER 100 KR</span>
          </div>
        </div>
      </div>

      <div style={{ padding: "16px 20px 8px" }}>
        <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.25em", color: P.muted, marginBottom: 10 }}>BETALINGSMETODER · 04</div>
        {["Visa","Mastercard","Vipps","Klarna"].map((m) => (
          <div key={m} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: `1px solid ${P.border}`, fontSize: 14 }}>
            <span>{m}</span>
            <span style={{ fontFamily: M, fontSize: 10, color: P.brass, letterSpacing: "0.15em" }}>99%</span>
          </div>
        ))}
      </div>

      <div style={{ padding: "12px 20px 16px", borderTop: `1px solid ${P.border}`, marginTop: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontFamily: M, fontSize: 10, color: P.muted, letterSpacing: "0.15em" }}>4 / 7 FUNNET</span>
        <div style={{ display: "flex", fontFamily: M, fontSize: 10, letterSpacing: "0.15em" }}>
          <span style={{ padding: "4px 8px", background: P.text, color: P.surface }}>NO</span>
          <span style={{ padding: "4px 8px", color: P.muted }}>EN</span>
        </div>
      </div>
    </div>
  );
}

function MynteDashboard() {
  return (
    <div style={{ background: P.surface, border: `1px solid ${P.border}` }}>
      <nav style={{ padding: "20px 36px", borderBottom: `1px solid ${P.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", gap: 56, alignItems: "center" }}>
          <span style={{ fontFamily: D, fontSize: 26, fontWeight: 400 }}>Mynte</span>
          <div style={{ display: "flex", gap: 32, fontFamily: M, fontSize: 11, letterSpacing: "0.18em" }}>
            <span style={{ borderBottom: `1px solid ${P.text}`, paddingBottom: 4 }}>OVERSIKT</span>
            <span style={{ color: P.muted }}>BUTIKKER</span>
            <span style={{ color: P.muted }}>POENG</span>
            <span style={{ color: P.muted }}>MEDLEMSKAP</span>
          </div>
        </div>
        <div style={{ display: "flex", gap: 16, alignItems: "center", fontFamily: M, fontSize: 11, letterSpacing: "0.15em" }}>
          <span style={{ color: P.muted }}>NO / EN</span>
          <span style={{ width: 32, height: 32, border: `1px solid ${P.border}`, display: "grid", placeItems: "center", fontFamily: D, fontSize: 16 }}>S</span>
        </div>
      </nav>

      <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr", borderBottom: `1px solid ${P.border}` }}>
        <div style={{ padding: "56px 36px", borderRight: `1px solid ${P.border}` }}>
          <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.muted, marginBottom: 24 }}>OPPTJENT · JUNI 2026</div>
          <div style={{ fontFamily: D, fontSize: 120, fontWeight: 300, letterSpacing: "-0.04em", lineHeight: 0.95 }}>1 240</div>
          <div style={{ fontFamily: M, fontSize: 11, letterSpacing: "0.2em", color: P.brass, marginTop: 8 }}>POENG · TILSVARER 124 KR</div>
          <div style={{ marginTop: 36, fontSize: 18, color: P.muted, maxWidth: 380, lineHeight: 1.6, fontStyle: "italic", fontFamily: D }}>
            «18% over forrige måned. Du henter ut mer av hver handel enn 9 av 10 medlemmer i ditt distrikt.»
          </div>
        </div>
        <div style={{ padding: "40px 36px", background: P.paper }}>
          <div style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.3em", color: P.muted, marginBottom: 24 }}>FORDELING</div>
          {[["EuroBonus","800 p","64%"],["Trumf","2.8 %","28%"],["Coop","98 kr","8%"]].map(([n,v,p]) => (
            <div key={n} style={{ padding: "16px 0", borderBottom: `1px solid ${P.border}`, display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
              <div>
                <div style={{ fontFamily: D, fontSize: 22, fontWeight: 400 }}>{n}</div>
                <div style={{ fontFamily: M, fontSize: 10, color: P.muted, letterSpacing: "0.15em", marginTop: 2 }}>{v}</div>
              </div>
              <span style={{ fontFamily: M, fontSize: 11, color: P.brass, letterSpacing: "0.15em" }}>{p}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: "32px 36px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
          <div style={{ fontFamily: D, fontSize: 32, fontWeight: 400, letterSpacing: "-0.02em" }}>Siste handler</div>
          <span style={{ fontFamily: M, fontSize: 10, letterSpacing: "0.2em", color: P.muted }}>SE ALLE 24 →</span>
        </div>
        <div style={{ border: `1px solid ${P.border}` }}>
          <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1.6fr 1.2fr 100px", padding: "12px 20px", background: P.paper, fontFamily: M, fontSize: 10, letterSpacing: "0.2em", color: P.muted, borderBottom: `1px solid ${P.border}` }}>
            <span>FORHANDLER</span><span>METODER</span><span>BONUS</span><span style={{ textAlign: "right" }}>DATO</span>
          </div>
          {[
            ["Komplett","komplett.no", ["Visa","Klarna"], "EuroBonus · 15 p", "14.06"],
            ["Meny","meny.no", ["Visa","Vipps"], "Trumf · 3 %", "12.06"],
            ["XXL Sport","xxl.no", ["Mastercard","Vipps"], "EuroBonus · 8 p", "09.06"],
            ["LEGO","lego.com", ["Visa","Apple Pay"], "Trumf · 2 %", "06.06"],
          ].map(([n,h,m,b,d]) => (
            <div key={h} style={{ display: "grid", gridTemplateColumns: "1.4fr 1.6fr 1.2fr 100px", padding: "16px 20px", borderTop: `1px solid ${P.border}`, alignItems: "center", fontSize: 14 }}>
              <div><div style={{ fontFamily: D, fontSize: 18 }}>{n}</div><div style={{ fontFamily: M, fontSize: 10, color: P.muted, letterSpacing: "0.1em" }}>{h}</div></div>
              <div style={{ fontFamily: M, fontSize: 11, color: P.muted, letterSpacing: "0.1em" }}>{m.join(" · ")}</div>
              <div style={{ fontFamily: M, fontSize: 11, color: P.brass, letterSpacing: "0.12em" }}>{b}</div>
              <div style={{ fontFamily: M, fontSize: 11, color: P.muted, textAlign: "right" }}>{d}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
